var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2a508d",
    d: "M11.8 19.2a3.2 3.2 0 0 0-3.2 3.1c0 1.8 1.5 3.2 3.2 3.2h5.7c2.6 0 2.9 2.2 3 2.4l3 16 .2.6 7.6 39.4c0 .2.6 7.5 9.1 7.5h58.4c8.6 0 8.9-6.3 9.1-7.5l7.5-38v-.7s0-4-1.3-5.6-5.2-2.4-5.2-2.4H29.4l-.6-.4a.9.9 0 0 1-.3-.4l-1.9-9.7c0-.2-1-7.5-9.1-7.5h-4.7zm40.3 76a7.4 7.4 0 1 0 0 14.9 7.4 7.4 0 0 0 0-15zm35.1 0a7.4 7.4 0 1 0 0 14.9 7.4 7.4 0 0 0 0-15z",
    className: "icon_svg__black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.4 59.3 53 66.6l9.9 10 7.3 7.3 7.4-7.4 9.9-9.9-7.4-7.3-9.9 9.8Z",
    className: "icon_svg__white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.7 45.3h9.1v25.6h-9.1z",
    className: "icon_svg__white"
  })));
};
export default SvgIcon;